<template>
  <div class="tab-content">
    <el-form ref="form" label-position="top" size="small">
      <div class="features-container">
        <div class="features-header">
          <div class="header-col col-name">
            <span>Active Features</span>
          </div>
          <div class="header-col col-action">
            <span>Enable</span>
          </div>
          <div class="header-col col-action">
            <span>Order</span>
          </div>
        </div>
        <div class="features-list">
          <div class="feature-item">
            <div class="feature-col col-name">
              <span>Listening Guide</span>
            </div>
            <div class="feature-col col-action">
              <el-switch v-model="featuresData.listening_guide.is_enable" active-color="#A5C2CB" />
            </div>
            <div class="feature-col col-action">
              <el-select
                class="content" v-model="featuresData.listening_guide.order" style="width: 80px;" placeholder=" "
                @change="listeningGuideChange"
              >
                <el-option key="1" label="1" :value="1"></el-option>
                <el-option key="2" label="2" :value="2"></el-option>
                <el-option key="3" label="3" :value="3"></el-option>
                <el-option key="4" label="4" :value="4"></el-option>
                <el-option key="5" label="5" :value="5"></el-option>
              </el-select>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-col col-name">
              <span>Discography</span>
            </div>
            <div class="feature-col col-action">
              <el-switch v-model="featuresData.discography.is_enable" active-color="#A5C2CB" />
            </div>
            <div class="feature-col col-action">
              <el-select
                class="content" v-model="featuresData.discography.order" style="width: 80px;" placeholder=" "
                @change="discographyChange"
              >
                <el-option key="1" label="1" :value="1"></el-option>
                <el-option key="2" label="2" :value="2"></el-option>
                <el-option key="3" label="3" :value="3"></el-option>
                <el-option key="4" label="4" :value="4"></el-option>
                <el-option key="5" label="5" :value="5"></el-option>
              </el-select>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-col col-name">
              <span>Frequency Graphs</span>
            </div>
            <div class="feature-col col-action">
              <el-switch v-model="featuresData.frequency_graphs.is_enable" active-color="#A5C2CB" />
            </div>
            <div class="feature-col col-action">
              <el-select
                class="content" v-model="featuresData.frequency_graphs.order" style="width: 80px;" placeholder=" "
                @change="frequencyGraphsChange"
              >
                <el-option key="1" label="1" :value="1"></el-option>
                <el-option key="2" label="2" :value="2"></el-option>
                <el-option key="3" label="3" :value="3"></el-option>
                <el-option key="4" label="4" :value="4"></el-option>
                <el-option key="5" label="5" :value="5"></el-option>
              </el-select>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-col col-name">
              <span>Tech Specs</span>
            </div>
            <div class="feature-col col-action">
              <el-switch v-model="featuresData.tech_specs.is_enable" active-color="#A5C2CB" />
            </div>
            <div class="feature-col col-action">
              <el-select
                class="content" v-model="featuresData.tech_specs.order" style="width: 80px;" placeholder=" "
                @change="techSpecsChange"
              >
                <el-option key="1" label="1" :value="1"></el-option>
                <el-option key="2" label="2" :value="2"></el-option>
                <el-option key="3" label="3" :value="3"></el-option>
                <el-option key="4" label="4" :value="4"></el-option>
                <el-option key="5" label="5" :value="5"></el-option>
              </el-select>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-col col-name">
              <span>Images</span>
            </div>
            <div class="feature-col col-action">
              <el-switch v-model="featuresData.images.is_enable" active-color="#A5C2CB" />
            </div>
            <div class="feature-col col-action">
              <el-select
                class="content" v-model="featuresData.images.order" style="width: 80px;" placeholder=" "
                @change="imagesChange"
              >
                <el-option key="1" label="1" :value="1"></el-option>
                <el-option key="2" label="2" :value="2"></el-option>
                <el-option key="3" label="3" :value="3"></el-option>
                <el-option key="4" label="4" :value="4"></el-option>
                <el-option key="5" label="5" :value="5"></el-option>
              </el-select>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-col col-name">
              <span>Products in Player</span>
            </div>
            <div class="feature-col col-action">
              <el-select size="mini" v-model="featuresData.products_in_player.max_num" style="width: 150px;" placeholder=" ">
                <el-option key="1" label="5 maximum" :value="5"></el-option>
                <el-option key="2" label="No limit" :value="99999"></el-option>
              </el-select>
            </div>
            <div class="feature-col col-action"></div>
          </div>
          <div class="feature-item">
            <div class="feature-col col-name">
              <span>Other Brands Products</span>
            </div>
            <div class="feature-col col-action">
              <el-switch v-model="featuresData.other_brands_products.is_enable" active-color="#A5C2CB" />
            </div>
             <div class="feature-col col-action"></div>
          </div>
          <div class="feature-item">
            <div class="feature-col col-name">
              <span>ATK Songs</span>
            </div>
            <div class="feature-col col-action">
              <el-select size="mini" v-model="featuresData.atk_songs.max_num" style="width: 150px;" placeholder=" ">
                <el-option key="1" label="3 maximum" :value="3"></el-option>
                <el-option key="2" label="No limit" :value="99999"></el-option>
              </el-select>
            </div>
             <div class="feature-col col-action"></div>
          </div>
          <div class="feature-item">
            <div class="feature-col col-name">
              <span>My Audio</span>
            </div>
            <div class="feature-col col-action">
              <el-switch v-model="featuresData.my_audio.is_enable" active-color="#A5C2CB" />
            </div>
            <div class="feature-col col-action"></div>
          </div>
          <div class="feature-item">
            <div class="feature-col col-name">
              <span>Display Price</span>
            </div>
            <div class="feature-col col-action">
              <el-switch v-model="featuresData.display_price.is_enable" active-color="#A5C2CB" />
            </div>
            <div class="feature-col col-action"></div>
          </div>
        </div>
      </div>
      <el-row style="margin-top: 30px;">
        <el-form-item>
          <el-button class="el-btn-blue" @click="updateInstance" :loading="flagLoading.save">SAVE CHANGES</el-button>
          <el-button @click="returnBack">CANCEL</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <PermissionFeaDisco
      :flagVisible="flagVisible.permissionFeaDisco" @closeModal="flagVisible.permissionFeaDisco = false"
    />
    <PermissionFeaFreq
      :flagVisible="flagVisible.permissionFeaFreq" @closeModal="flagVisible.permissionFeaFreq = false"
    />
    <PermissionFeaTech
      :flagVisible="flagVisible.permissionFeaTech" @closeModal="flagVisible.permissionFeaTech = false"
    />
    <PermissionProducts
      :flagVisible="flagVisible.permissionProducts" @closeModal="flagVisible.permissionProducts = false"
    />
    <PermissionSources
      :flagVisible="flagVisible.permissionSources" @closeModal="flagVisible.permissionSources = false"
    />
    <PermissionOtherProducts
      :flagVisible="flagVisible.permissionOtherProducts" @closeModal="flagVisible.permissionOtherProducts = false"
    />
    <PermissionMyAudio
      :flagVisible="flagVisible.permissionMyAudio" @closeModal="flagVisible.permissionMyAudio = false"
    />
  </div>
</template>

<script>
import { reactive } from 'vue'
import PermissionFeaDisco from '@/components/instances/permissions/FeaDisco.vue'
import PermissionFeaFreq from '@/components/instances/permissions/FeaFreq.vue'
import PermissionFeaTech from '@/components/instances/permissions/FeaTech.vue'
import PermissionProducts from '@/components/instances/permissions/Products.vue'
import PermissionSources from '@/components/instances/permissions/Sources.vue'
import PermissionOtherProducts from '@/components/instances/permissions/OtherProducts.vue'
import PermissionMyAudio from '@/components/instances/permissions/MyAudio.vue'
export default {
  name: 'TabFeatures',
  props: {
    role: String,
    actionItem: Object
  },
  emits: [],
  components: {
    PermissionFeaDisco,
    PermissionFeaFreq,
    PermissionFeaTech,
    PermissionProducts,
    PermissionSources,
    PermissionOtherProducts,
    PermissionMyAudio
  },
  data () {
    const flagLoading = reactive({
      save: false
    })
    const flagVisible = reactive({
      permissionFeaDisco: false,
      permissionFeaFreq: false,
      permissionFeaTech: false,
      permissionProducts: false,
      permissionSources: false,
      permissionOtherProducts: false,
      permissionMyAudio: false
    })
    const actionItems = reactive({
    })
    const featuresData = {
      listening_guide: {},
      discography: {},
      frequency_graphs: {},
      tech_specs: {},
      images: {},
      products_in_player: {},
      atk_songs: {},
      other_brands_products: {},
      my_audio: {},
      display_price: {}
    }
    return {
      instance: {},
      features: {},
      featuresData,
      flagLoading,
      flagVisible,
      actionItems
    }
  },
  created: function () {
  },
  mounted () {
  },
  computed: {
  },
  watch: {
    actionItem: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          if (val) this.instance = { ...val }
          if (val && val.features) {
            this.features = { ...val.features }
            this.generateFeaturesData()
          }
        }
      },
      deep: true
    }
  },
  methods: {
    updateInstance: function () {
      this.flagLoading.save = true
      const url = `/api/v1/atk_player${this.role === 'admin' ? '/admin' : ''}/instances/${this.instance._id}`
      const that = this
      this.features.listening_guide = { is_enable: this.featuresData.listening_guide.is_enable ? 1 : 0, order: parseInt(this.featuresData.listening_guide.order) }
      this.features.discography = { is_enable: this.featuresData.discography.is_enable ? 1 : 0, order: parseInt(this.featuresData.discography.order) }
      this.features.frequency_graphs = { is_enable: this.featuresData.frequency_graphs.is_enable ? 1 : 0, order: parseInt(this.featuresData.frequency_graphs.order) }
      this.features.tech_specs = { is_enable: this.featuresData.tech_specs.is_enable ? 1 : 0, order: parseInt(this.featuresData.tech_specs.order) }
      this.features.images = { is_enable: this.featuresData.images.is_enable ? 1 : 0, order: parseInt(this.featuresData.images.order) }
      this.features.products_in_player = { max_num: this.featuresData.products_in_player.max_num }
      this.features.atk_songs = { max_num: this.featuresData.atk_songs.max_num }
      this.features.other_brands_products = { is_enable: this.featuresData.other_brands_products.is_enable ? 1 : 0 }
      this.features.my_audio = { is_enable: this.featuresData.my_audio.is_enable ? 1 : 0 }
      this.features.display_price = { is_enable: this.featuresData.display_price.is_enable ? 1 : 0 }
      const body = { features: this.features }
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Update success' })
        } else {
          switch (res.msg) {
            case 'permission error - features - discography':
              that.featuresData.discography.is_enable = false
              that.flagVisible.permissionFeaDisco = true
              break
            case 'permission error - features - frequency_graphs':
              that.featuresData.frequency_graphs.is_enable = false
              that.flagVisible.permissionFeaFreq = true
              break
            case 'permission error - features - tech_specs':
              that.featuresData.tech_specs.is_enable = false
              that.flagVisible.permissionFeaTech = true
              break
            case 'permission error - features - products_in_player':
              that.featuresData.products_in_player.max_num = 5
              that.flagVisible.permissionProducts = true
              break
            case 'permission error - features - other_brands_products':
              that.featuresData.other_brands_products.is_enable = false
              that.flagVisible.permissionOtherProducts = true
              break
            case 'permission error - features - atk_songs':
              that.featuresData.atk_songs.max_num = 3
              that.flagVisible.permissionSources = true
              break
            case 'permission error - features - my_audio':
              that.featuresData.my_audio.is_enable = false
              that.flagVisible.permissionMyAudio = true
              break
            default:
              that.$message({ type: 'error', message: res.msg })
          }
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('updateInstance', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    },
    returnBack: function () {
      this.$router.go(-1)
    },
    generateFeaturesData: function () {
      const featuresData = {}
      featuresData.listening_guide = { is_enable: this.features.listening_guide.is_enable === 1, order: this.features.listening_guide.order ? this.features.listening_guide.order : 1 }
      featuresData.discography = { is_enable: this.features.discography.is_enable === 1, order: this.features.discography.order ? this.features.discography.order : 2 }
      featuresData.frequency_graphs = { is_enable: this.features.frequency_graphs.is_enable === 1, order: this.features.frequency_graphs.order ? this.features.frequency_graphs.order : 3 }
      featuresData.tech_specs = { is_enable: this.features.tech_specs.is_enable === 1, order: this.features.tech_specs.order ? this.features.tech_specs.order : 4 }
      featuresData.images = { is_enable: this.features.images.is_enable === 1, order: this.features.images.order ? this.features.images.order : 5 }
      featuresData.products_in_player = { max_num: this.features.products_in_player.max_num }
      featuresData.atk_songs = { max_num: this.features.atk_songs.max_num }
      featuresData.other_brands_products = { is_enable: this.features.other_brands_products.is_enable === 1 }
      featuresData.my_audio = { is_enable: this.features.my_audio.is_enable === 1 }
      featuresData.display_price = { is_enable: this.features.display_price.is_enable === 1 }
      this.featuresData = featuresData
    },
    listeningGuideChange: function () {
      const oredrArrFull = [1, 2, 3, 4, 5]
      const oredrArr = []
      oredrArr.push(this.featuresData.discography.order)
      oredrArr.push(this.featuresData.frequency_graphs.order)
      oredrArr.push(this.featuresData.tech_specs.order)
      oredrArr.push(this.featuresData.images.order)
      const cj = [...new Set(oredrArrFull)].filter(item => !oredrArr.includes(item))
      if (this.featuresData.listening_guide.order === this.featuresData.discography.order) {
        this.featuresData.discography.order = cj[0]
      }
      if (this.featuresData.listening_guide.order === this.featuresData.frequency_graphs.order) {
        this.featuresData.frequency_graphs.order = cj[0]
      }
      if (this.featuresData.listening_guide.order === this.featuresData.tech_specs.order) {
        this.featuresData.tech_specs.order = cj[0]
      }
      if (this.featuresData.listening_guide.order === this.featuresData.images.order) {
        this.featuresData.images.order = cj[0]
      }
    },
    discographyChange: function () {
      const oredrArrFull = [1, 2, 3, 4, 5]
      const oredrArr = []
      oredrArr.push(this.featuresData.listening_guide.order)
      oredrArr.push(this.featuresData.frequency_graphs.order)
      oredrArr.push(this.featuresData.tech_specs.order)
      oredrArr.push(this.featuresData.images.order)
      const cj = [...new Set(oredrArrFull)].filter(item => !oredrArr.includes(item))
      if (this.featuresData.discography.order === this.featuresData.listening_guide.order) {
        this.featuresData.listening_guide.order = cj[0]
      }
      if (this.featuresData.discography.order === this.featuresData.frequency_graphs.order) {
        this.featuresData.frequency_graphs.order = cj[0]
      }
      if (this.featuresData.discography.order === this.featuresData.tech_specs.order) {
        this.featuresData.tech_specs.order = cj[0]
      }
      if (this.featuresData.discography.order === this.featuresData.images.order) {
        this.featuresData.images.order = cj[0]
      }
    },
    frequencyGraphsChange: function () {
      const oredrArrFull = [1, 2, 3, 4, 5]
      const oredrArr = []
      oredrArr.push(this.featuresData.listening_guide.order)
      oredrArr.push(this.featuresData.discography.order)
      oredrArr.push(this.featuresData.tech_specs.order)
      oredrArr.push(this.featuresData.images.order)
      const cj = [...new Set(oredrArrFull)].filter(item => !oredrArr.includes(item))
      if (this.featuresData.frequency_graphs.order === this.featuresData.listening_guide.order) {
        this.featuresData.listening_guide.order = cj[0]
      }
      if (this.featuresData.frequency_graphs.order === this.featuresData.discography.order) {
        this.featuresData.discography.order = cj[0]
      }
      if (this.featuresData.frequency_graphs.order === this.featuresData.tech_specs.order) {
        this.featuresData.tech_specs.order = cj[0]
      }
      if (this.featuresData.frequency_graphs.order === this.featuresData.images.order) {
        this.featuresData.images.order = cj[0]
      }
    },
    techSpecsChange: function () {
      const oredrArrFull = [1, 2, 3, 4, 5]
      const oredrArr = []
      oredrArr.push(this.featuresData.listening_guide.order)
      oredrArr.push(this.featuresData.discography.order)
      oredrArr.push(this.featuresData.frequency_graphs.order)
      oredrArr.push(this.featuresData.images.order)
      const cj = [...new Set(oredrArrFull)].filter(item => !oredrArr.includes(item))
      if (this.featuresData.tech_specs.order === this.featuresData.listening_guide.order) {
        this.featuresData.listening_guide.order = cj[0]
      }
      if (this.featuresData.tech_specs.order === this.featuresData.discography.order) {
        this.featuresData.discography.order = cj[0]
      }
      if (this.featuresData.tech_specs.order === this.featuresData.frequency_graphs.order) {
        this.featuresData.frequency_graphs.order = cj[0]
      }
      if (this.featuresData.tech_specs.order === this.featuresData.images.order) {
        this.featuresData.images.order = cj[0]
      }
    },
    imagesChange: function () {
      const oredrArrFull = [1, 2, 3, 4, 5]
      const oredrArr = []
      oredrArr.push(this.featuresData.listening_guide.order)
      oredrArr.push(this.featuresData.discography.order)
      oredrArr.push(this.featuresData.frequency_graphs.order)
      oredrArr.push(this.featuresData.tech_specs.order)
      const cj = [...new Set(oredrArrFull)].filter(item => !oredrArr.includes(item))
      if (this.featuresData.images.order === this.featuresData.listening_guide.order) {
        this.featuresData.listening_guide.order = cj[0]
      }
      if (this.featuresData.images.order === this.featuresData.discography.order) {
        this.featuresData.discography.order = cj[0]
      }
      if (this.featuresData.images.order === this.featuresData.frequency_graphs.order) {
        this.featuresData.frequency_graphs.order = cj[0]
      }
      if (this.featuresData.images.order === this.featuresData.tech_specs.order) {
        this.featuresData.tech_specs.order = cj[0]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.features-container {
  width: 485px;
  .features-header {
    padding: 12px 16px;
    background-color: #DBE7EA;
    border-radius: 8px;
    font-size: 18px;
    font-weight: bold;
    display: flex;
    .col-name {
      width: 70%;
    }
    .col-action {
      width: 30%;
    }
  }
  .features-list {
    margin-top: 16px;
    .feature-item {
      padding: 12px 16px;
      display: flex;
      align-items: center;
      font-size: 18px;
      .col-name {
        width: 70%;
      }
      .col-action {
        width: 30%;
      }
    }
  }
}
</style>
